/**
 * Puerta de la SPA: loading, login, reset de clave, forzar password y MainLayout.
 */
import React, { useEffect } from 'react';
import Auth from './components/Auth';
import AuthShell from './components/AuthShell';
import ForcePasswordChange from './components/ForcePasswordChange';
import PasswordResetHandler from './components/PasswordResetHandler';
import MainLayout from './components/MainLayout';
import { useAuth } from './AuthContext';
import { useNavigation } from './NavigationContext';
import { ink } from './components/admin/studioUi';

const isPasswordResetUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('mode') === 'resetPassword' && params.has('oobCode');
};

function App() {
  const { user, userData, loading, fetchUserData, fetchWithAuth, API_URL } = useAuth();
  const { view, setView, setAdminSubView } = useNavigation();

  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `* { box-sizing: border-box; } body { margin: 0; }`;
    document.head.append(style);
    return () => style.remove();
  }, []);

  // Hook to handle auth actions from URL (like password reset)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get('mode');
    const reportId = params.get('reportId');
    const initialView = params.get('view');
    const initialSubView = params.get('subview');

    if (mode === 'resetPassword' && params.has('oobCode')) {
      setView('resetPassword');
      return;
    }

    if (reportId) {
      sessionStorage.setItem('redirectReportId', reportId);
    }

    if (initialView) {
      setView(initialView);
      if (initialSubView) {
        setAdminSubView(initialSubView);
      }
    }
    
    if (reportId || initialView || initialSubView) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [setView, setAdminSubView]);

  if (view === 'resetPassword' || isPasswordResetUrl()) {
    return <PasswordResetHandler />;
  }

  if (loading) {
    return (
      <AuthShell title="Cargando" subtitle="Preparando el entorno.">
        <p style={{ color: ink.muted, margin: 0 }}>Un momento…</p>
      </AuthShell>
    );
  }

  if (!user) {
    return <Auth />;
  }

  if (userData && userData.passwordChangeRequired) {
    return (
      <ForcePasswordChange
        user={user}
        onPasswordChanged={() => fetchUserData(user)}
        fetchWithAuth={fetchWithAuth}
        API_URL={API_URL}
      />
    );
  }
  

  return (
    <MainLayout />
  );
}

export default App;
